module.exports = __webpack_public_path__ + "img/ques-title.c71b751e.png";